import Vue from 'vue'
import Router from 'vue-router'
import routers from './routers'

Vue.use(Router)

const router = new Router({
    linkActiveClass: 'active',
    routes: routers
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
// router.beforeEach((to, from, next) => {
//     if (isCanUseThisModule(to, from, next)) {
//         next()
//     } else {
//         next({
//             path: '/main/privilegeValidator',
//             query: {
//                 redirect: to.fullPath
//             },
//             replace: true
//         })
//     }
// })

// function isCanUseThisModule(to, from, next) {
//     return to.matched.every(record => {
//         if (record.meta.role) {
//             return store.getters.canIUse(record.meta.role, record.meta.privilegeId)
//         } else {
//             return true
//         }
//     })
// }

export default router
